import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchTeachers(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/teachers', {params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchTeacher(ctx, { id }) {
            return new  Promise((resolve, reject) => {
                axios
                    .get(`/teachers/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addTeacher(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/teachers', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteTeacher(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/teachers/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateTeacher(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/teachers/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error)) 
            })
        },
        downloadTeachers(ctx, data)  {
            return new Promise((resolve, reject) => 
            {
              axios
                  .post('/download-teachers',  data,{ responseType: 'arraybuffer' })
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })
        }

    }
}